import { LocalStorageKey } from '../LocalStorageKey';

export function getSampleCodeSelectedLanguageVariant() {
  try {
    const str = localStorage.getItem(LocalStorageKey.SAMPLE_CODE_SELECTED_LANGUAGE_VARIANT);
    if (str) {
      const obj = JSON.parse(str);
      if (
        obj &&
        typeof obj === 'object' &&
        typeof obj.language === 'string' &&
        typeof obj.variant === 'string'
      ) {
        return {
          language: obj.language,
          variant: obj.variant,
        };
      }
    }
  } catch (error) {
    if (error) {
      //
    }
  }
  return undefined;
}

export function setSampleCodeSelectedLanguageVariant(
  language: string | undefined,
  variant: string | undefined,
) {
  try {
    if (!language || !variant) {
      localStorage.removeItem(LocalStorageKey.SAMPLE_CODE_SELECTED_LANGUAGE_VARIANT);
      return;
    }

    localStorage.setItem(
      LocalStorageKey.SAMPLE_CODE_SELECTED_LANGUAGE_VARIANT,
      JSON.stringify({ language, variant }),
    );
  } catch (error) {
    if (error) {
      //
    }
  }
}
